import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./columns";

export function HouseReceivedTablePage() {
  return (
    <ServerDataGrid
      columns={columns}
      getRowId={(row) => row.house.id}
      apiEndpoint="/datagrid/house-received"
      tableName="house"
      enableCreate={false}
      enableSearch={true}
      pageSizeOptions={[25, 50, 100, 250, 500]}
      height={"calc(100vh - 52.6px)"}
      initialStateOverride={{
        sorting: { sortModel: [{ field: "house.received", sort: "desc" }] },
      }}
    />
  );
}
